export default {
  filters: {
    tooltip: {
      remove_filter: 'Remove Filter'
    },
    errors: {
      field_required: 'Field is required',
      operator_required: 'Operator is required',
      seal_range_order: 'The start cannot be greater than the end',
      seal_range_limit: 'The range cannot exceed 1000 seals',
      no_empty_field_and_operator: 'Searches cannot be saved with empty fields in Identifier and Operator.',
      saved_record_limit: 'You have reached the limit of {{count}} saved searches.',
      record_already_exist:
        'There already exists a saved search with the same search parameters with this name of: {{name}}',
      saved_record_limit_replace_tip: 'Do you want to replace the record named: “{{record}}”” with the new record?'
    },
    message: {
      filter_cant_be_nameless: 'The filter name cannot be empty',
      load_saved_record: 'Load saved record',
      edit_record_name: 'Edit record name',
      record_details: 'Record details',
      hide_details: 'Hide details',
      show_object_record_details: 'View record data',
      hide_object_record_details: 'Hide record data',
      how_to_use_filters: 'How to use it?',
      filter_will_delete: 'This Filter will be deleted from your search records',
      filter_save_name: 'Filter name'
    },
    tips: {
      add_filters: 'Add Main Filters',
      nest_filters: 'Nest Filters and optimize search',
      save_filters: 'Save current filters with a name',
      manage_filters: 'View and Manage Saved Filters',
      select_field: 'Select a field',
      field: 'Identificador',
      select_operator: 'select an operator',
      operator: 'Operator'
    },
    fields: {
      client_name_unaccent: 'Client name',
      olt_id: 'OLT',
      host: 'Host',
      subscription_name: 'Name',
      subscription_user: 'User',
      subscription_last_name: 'Lastname',
      service_pack_id: 'Pack'
    },
    operators: {
      cont: 'Contains',
      not_cont: 'Does not contain',
      blank: 'Is null or empty',
      cont_any: 'Contains any of',
      cont_all: 'Contains all',
      does_not_match: 'Does not match',
      does_not_match_all: 'Does not match all',
      does_not_match_any: 'Does not match any',
      end: 'Ends with',
      end_all: 'Ends with all',
      end_any: 'Ends with any of',
      eq: 'Is equal to',
      eq_any: 'Is equal to any of',
      gt: 'Greater than',
      gt_all: 'Greater than all',
      gt_any: 'Greater than any',
      gteq: 'Greater than or equal to',
      gteq_all: 'Greater than or equal to all',
      gteq_any: 'Greater than or equal to any',
      i_cont: 'Contains (case insensitive)',
      i_cont_all: 'Contains all (case insensitive)',
      i_cont_any: 'Contains any of (case insensitive)',
      in: 'In',
      lt: 'Less than',
      lt_all: 'Less than all',
      lt_any: 'Less than any',
      lteq: 'Less than or equal to',
      lteq_all: 'Less than or equal to all',
      lteq_any: 'Less than or equal to any',
      matches: 'Matches',
      matches_all: 'Matches all',
      matches_any: 'Matches any',
      not_cont_all: 'Does not contain all',
      not_cont_any: 'Does not contain any of',
      not_end: 'Does not end with',
      not_end_all: 'Does not end with all',
      not_end_any: 'Does not end with any of',
      not_eq: 'Is not equal to',
      not_eq_all: 'Is not equal to all',
      not_i_cont: 'Does not contain (case insensitive)',
      not_i_cont_any: 'Does not contain any of (case insensitive)',
      not_null: 'With information',
      not_in: 'Not in',
      not_start: 'Does not start with',
      not_start_all: 'Does not start with all',
      not_start_any: 'Does not start with any of',
      null: 'Without information',
      present: 'Is not null and not empty',
      start: 'Starts with',
      start_all: 'Starts with all',
      start_any: 'Starts with any of',
      true: 'Is true',
      false: 'Is false'
    }
  }
};
